+function($) {
    $(function() {
        $('.ui.accordion.brand.music').accordion();

        var musics = {
            family: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/home.m4a',
            refrain: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/refrain.mp3',
            alitterstory: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/alitterboy.mp3',
            sunburst: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/Sunburst.mp3', 
            beacauseofyou: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/beacauseofyou.mp3',
            breathandlife: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/breathandlife.mp3',
            friendshipe: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/friendships.mp3',
            frontier: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/frontier.mp3',
            hello: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/hello.mp3',
            introthedawn: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/introthedawn.mp3',
            lastreunion: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/lastreunion.mp3',
            maskedheroes: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/masked-heroes.mp3',
            purplepassion: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/purplepassion.mp3',
            remember: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/remember.mp3',
            ringtone: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/ringtone.mp3',
            riverflowinyou: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/riverflowinyou.mp3',
            silent: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/silent.mp3',
            sky: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/sky.mp3',
            spring: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/spring.mp3',
            summer: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/summer.mp3',
            summertime: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/summertime.mp3',
            therightpath: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/therightpath.mp3',
            town: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/town.mp3',
            trip: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/trip.mp3',
            victory: 'http://9daye-attachment.oss-cn-shanghai.aliyuncs.com/ecom/music/victory.mp3'
        };

        function pauseAll() {
            $('.music-play').each(function() {
                var target = $(this);

                if (!target.data('clicked')) {
                    if (target.data('audio-player')) {
                        target.data('audio-player').pause();
                    }

                    target.removeClass('played');
                }
            });
        }

        $('.brand.music').on('click', '.music-play', function() {
            var target = $(this), 
                musicName = target.data('audio'), 
                musicUrl=musics[musicName];

            target.data('clicked', true);

            pauseAll();

            if (!target.data('audio-player')) {
                target.data(
                    'audio-player', 
                    new Audio(musicUrl)
                );
            }

            if (!target.hasClass('played')) {
                target.data('audio-player').play();
                target.addClass('played');
            }else {
                target.data('audio-player').pause();
                target.removeClass('played');
            }

            target.data('clicked', false);
        });
    });
}(jQuery);